import { useNavigate } from "react-router-dom";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React from "react";

const ChangePassword = () => {

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => {
    setShowPassword1((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => {
    setShowPassword2((prev) => !prev);
  };
  const handleMouseDownPassword2 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <>
      <div className="main_title">
        <h1>Change Password</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-profile")}>Manage Profile</button>
          {' '} - Change Password
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_33">
              <label htmlFor="password">Old Password</label>
              <TextField
                id="password"
                placeholder="Enter Old Password"
                fullWidth
                hiddenLabel
                type={showPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="eye_btn">
                      <IconButton
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="newpassword">New Password</label>
              <TextField
                id="newpassword"
                placeholder="Enter New Password"
                hiddenLabel
                fullWidth
                type={showPassword1 ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="eye_btn">
                      <IconButton
                        aria-label={
                          showPassword1 ? "Hide password" : "Show password"
                        }
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword1}
                        edge="end"
                      >
                        {showPassword1 ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="confirmpassword">Confirm New Password</label>
              <TextField
                id="confirmpassword"
                placeholder="Enter Confirm New Password"
                hiddenLabel
                fullWidth
                type={showPassword2 ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="eye_btn">
                      <IconButton
                        aria-label={
                          showPassword2 ? "Hide password" : "Show password"
                        }
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                        edge="end"
                      >
                        {showPassword2 ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary">Next</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
